import PropertyView from "components/common/views/PropertyView";
import { AppPropertyType } from "components/common/views/PropertyViewValue";

const AgricultureStatsPropertyView = (props: { label: string, value: any, propertyType: AppPropertyType, fixed?: number }) => {
    let value = props.value && props.fixed ? props.value.toFixed(props.fixed || 2) : props.value;
    const propertyType = value ? props.propertyType : 'string';
    value = value || '-';

    return <PropertyView
        label={props.label}
        value={value}
        propertyType={propertyType}
        className="w-1/3 min-w-28 max-w-48"
    />
}

export default AgricultureStatsPropertyView;
